var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.$auth.isAuthenticated)?_c('AppBar',{attrs:{"title":"TT Portal","color":"white","portal-url":_vm.portalUrl,"buttons":_vm.moduleButtons,"menu-items":_vm.menuItems}}):_vm._e(),_c('v-main',[_c('Message'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }